var _excluded = ["text", "tooltip", "typography"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import getBorderColor from "../../../utils/getBorderColor";
import isNotEmpty from "../../../utils/isNotEmpty";
import unit from "../../../utils/unit";
import TextAtm from "../../atoms/TextAtm";
import TooltipMol from "../TooltipMol";
var textStyling = function textStyling(_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:inline-block;border-bottom:", " dashed ", ";"], unit(1), getBorderColor(theme, $onColor, "medium"));
};
export var Text = styled(TextAtm).withConfig({
  componentId: "sc-12jwhff-0"
})(textStyling);
export var StyledSpan = styled.span.withConfig({
  componentId: "sc-12jwhff-1"
})(textStyling);
export var Container = styled.div.withConfig({
  componentId: "sc-12jwhff-2"
})(function (_ref2) {
  var $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["display:inline-block;position:relative;&:hover ", "{border-color:", ";}"], Text, getBorderColor(theme, $onColor, "low"));
});
export var StyledTooltip = styled(TooltipMol).withConfig({
  componentId: "sc-12jwhff-3"
})(["> *:first-child{position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;}"]);
function TextWithTooltipMol(_ref3) {
  var text = _ref3.text,
    tooltip = _ref3.tooltip,
    typography = _ref3.typography,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Container, _extends({
    $onColor: onColor
  }, restProps), isNotEmpty(typography) ? /*#__PURE__*/React.createElement(Text, {
    typography: typography,
    $onColor: onColor
  }, text) : /*#__PURE__*/React.createElement(StyledSpan, {
    $onColor: onColor
  }, text), /*#__PURE__*/React.createElement(StyledTooltip, null, tooltip));
}
export default TextWithTooltipMol;